import React, { useImperativeHandle, useState } from "react";
import { Button } from "./Elements";
import Modal from "./Modal";
import { useDispatch } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { refreshLinksTable } from "../../common/helpers/refreshTables/refreshLinksTable";


type listItemType = {
    message: string
}
type statusListType = {
    errorList: Array<listItemType>,
    successList: Array<listItemType>,
    unLimited: boolean
}
export type PaymentLinkResultModalRefProps = {
    showMessage: (errorList: Array<listItemType>, successList: Array<listItemType>, unLimited: boolean) => void
}

type Props = {
    statusModalVisible: boolean,
    setStatusModalVisible: (isVisible: boolean) => void,
    sendTypeId?: number,
    linkHash?: string
}
const PaymentLinkResultModal = React.forwardRef<PaymentLinkResultModalRefProps, Props>
    (({ statusModalVisible, setStatusModalVisible, sendTypeId, linkHash }, ref) => {
        const [statusList, setStatusList] = useState<statusListType>({
            errorList: [],
            successList: [],
            unLimited: false
        });

        useImperativeHandle(ref, () => ({
            showMessage(errorList, successList, unLimited) {
                setStatusList({
                    errorList: errorList,
                    successList: successList,
                    unLimited: unLimited
                });
            }
        }));

        const thunkDispatch = useDispatch<ThunkDispatch<any, any, any>>();

        const getMessage = () => {
            if (statusList.unLimited) {
                if (statusList.successList.length == 0 && statusList.errorList.length > 0) {
                    return "Ödeme linki oluşturulurken hata meydana geldi. Hata mesajı: " + statusList.errorList[0].message;
                }
                if (statusList.errorList.length == 0) {
                    if (statusList.successList.length == 1) {
                        return "Link Başarılı bir şekilde oluşturulmuştur. Ekranda ödeme linki alanını kontrol ediniz.";
                    }
                }
            } else {
                if (statusList.successList.length == 0 && statusList.errorList.length > 0) {
                    return "Ödeme linkleri oluşturulurken hata meydana geldi. Hata mesajı: " + statusList.errorList[0].message;
                }
                if (statusList.errorList.length == 0) {
                    if (statusList.successList.length == 1 && sendTypeId == 4) {
                        return "Odeme linki başarılı bir şekilde oluşturuldu";
                    } else if (statusList.successList.length == 1) {
                        return "Odeme linki başarılı bir şekilde oluşturulup müşteriye gönderildi.";
                    } else {
                        return "Odeme linki başarılı bir şekilde oluşturulup seçtiğiniz müşterilere gönderildi.";
                    }
                }
                if (statusList.errorList.length > 0) {
                    return `${statusList.successList.length} Müşteriye link başarılı bir şekilde gönderildi. ${statusList.errorList.length} Müşteriye gönderilemedi `;
                }
            }
        }

        const getStatusImageUrl = () => {
            if (statusList.successList.length == 0) {
                return "/icons/basarisiz.svg";
            }
            if (statusList.errorList.length == 0) {
                return "/icons/basarili.svg";
            }
            if (statusList.errorList.length > 0) {
                return "/icons/basarisiz.svg";
            }
        }

        const handleClose = () => {
            refreshLinksTable(thunkDispatch);
            setStatusModalVisible(false);
        }

        return (
            <Modal openModal={statusModalVisible} setOpenModal={setStatusModalVisible}>
                <div>
                    <div className="sm:flex sm:items-start">
                        <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                            <h3 className="text-md leading-6 font-medium text-gray-900">
                                Bilgilendirme Mesajı
                            </h3>
                            <div className="flex justify-center">
                                <div className="mt-4 flex flex-row items-center">
                                    <img
                                        className="text-success h-10 w-10"
                                        src={getStatusImageUrl()}
                                        alt="success"
                                    />
                                    <p className="pl-2 text-sm text-gray-500">
                                        {getMessage()}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-5 mt-4 flex justify-end space-x-2">
                        <Button
                            color="gray"
                            hover="gray"
                            size="xs"
                            callback={handleClose}
                        >
                            Kapat
                        </Button>
                    </div>
                </div>
            </Modal>
        );
    })

export default PaymentLinkResultModal;